module.exports = __webpack_public_path__ + "img/stick_activites_parapente.a969efca.svg";